<template>
  <div class="member">
    <h3
      class="member__name"
      :title="name"
    >
      <component
        :is="link ? 'router-link' : 'span'"
        :to="link"
      >
        {{ name }}
      </component>
    </h3>
    <h4
      class="member__title"
      :title="title"
    >
      {{ title }}
    </h4>
    <v-list
      class="member__meta"
      :items="[{value: phone, icon: 'phone', link: 'tel:' + phone},
               {value: email, icon: 'email', link: 'mailto:' + email}]"
      :has-icons="true"
    />
    <v-badge
      v-if="admin"
      class="member__badge"
      text="Admin"
      :value="admin"
    />
  </div>
</template>

<script>
  import List from '@/molecules/List';
  import Badge from "@/atoms/Badge";

  export default {
    components: {
      'v-list': List,
      'v-badge': Badge
    },
    props: {
      name: {
        type: String,
        default: null
      },
      link: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
      phone: {
        type: String,
        default: null
      },
      email: {
        type: String,
        default: null
      },
      admin: {
        type: Number,
        default: 0
      },
      activated:{
        type:Number,
        default: 1
      }
    },
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .member {
    width: 100%;
    padding: .5rem 0 .5rem 1rem;
    margin-bottom: 1rem;
    border-left: solid 3px $tangerine;
    &__name
    &__title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__title {
      margin-bottom: .25em;
    }
    &__name {
      margin-bottom: 0;
    }
    &__meta {
      margin-bottom: 0;
    }
    &__badge {
      margin-top: .5rem;
    }
  }
</style>
